import React, {Component} from 'react';
import {errorMessageStyle, controlMaxWidthStyle, controlButtonStyle} from '../styles';
import ProjectService from '../members/project-service';
import AdminService from './admin-service';

const loadingFileStyle = {
    position: 'absolute',
    left: '-4px',
    top: '9px',
    width: '15px',
    height: '15px'
};

class AddOrEditProject extends Component {
    constructor(props) {
        super(props);
        const project = props.project;
        if (project.syndicateMembers) {
            project.syndicateMembers = project.syndicateMembers.toString();
        }

        this.state = {
            project: project,
            isSaving: false,
            errorMessage: '',
            loadingPictureData: false
        };
        this.adminService = AdminService
    }

    inputChanged = e => {
        const project = this.state.project;
        project[e.target.id] = e.target.value;
        this.setState({project: project});
    };

    saveProject = () => {
        this.setState({isSaving: true});
        const project = this.state.project;
        Object.keys(project).forEach(k => { if (project[k] === '') project[k] = null });
        if (project.syndicateMembers) {
            project.syndicateMembers = project.syndicateMembers.split(',').map(sm => sm.trim());
        }

        this.adminService.saveProject(project)
            .done(() => this.props.onClose())
            .fail(e => this.setState({errorMessage: e.responseText}))
            .always(() => this.setState({isSaving: false}))
    };

    loadPictureData = () => {
        const reader = new FileReader();
        reader.readAsDataURL(event.target.files[0]);
        this.setState({loadingPictureData: true});
        reader.onloadend = () => {
            const project = this.state.project;
            project.pictureData = reader.result;
            this.setState({loadingPictureData: false, project: project});
        }
    };

    render() {
        return (
            <div style={{marginTop: '20px'}}>
                <h4>{this.props.isAddProject ? 'Add Project' : 'Edit Project'}</h4>
                <form className="form-horizontal">
                    <div className="form-group">
                        <label htmlFor="title" className="col-sm-2 control-label">Title</label>
                        <div className="col-sm-10">
                            <input type="text"
                                   className="form-control"
                                   id="title"
                                   placeholder="Title"
                                   value={this.state.project.title}
                                   onChange={this.inputChanged}/>
                        </div>
                    </div>
                    <div className="form-group">
                        <label htmlFor="description" className="col-sm-2 control-label">Description</label>
                        <div className="col-sm-10">
                            <textarea className="form-control"
                                      rows="15"
                                      id="description"
                                      value={this.state.project.description}
                                      onChange={this.inputChanged}/>
                        </div>
                    </div>
                    <div className="form-group">
                        <label htmlFor="location" className="col-sm-2 control-label">Location</label>
                        <div className="col-sm-10">
                            <input type="text"
                                   className="form-control"
                                   id="location"
                                   placeholder="location"
                                   value={this.state.project.location}
                                   onChange={this.inputChanged}/>
                        </div>
                    </div>
                    <div className="form-group">
                        <label htmlFor="agency" className="col-sm-2 control-label">Agency</label>
                        <div className="col-sm-10">
                            <input type="text"
                                   className="form-control"
                                   style={controlMaxWidthStyle}
                                   id="agency"
                                   placeholder="Agency"
                                   value={this.state.project.agency}
                                   onChange={this.inputChanged}/>
                        </div>
                    </div>
                    <div className="form-group">
                        <label htmlFor="leadMandate" className="col-sm-2 control-label">Lead mandate</label>
                        <div className="col-sm-10">
                            <input type="text"
                                   className="form-control"
                                   style={controlMaxWidthStyle}
                                   id="leadMandate"
                                   placeholder="Lead mandate"
                                   value={this.state.project.leadMandate}
                                   onChange={this.inputChanged}/>
                        </div>
                    </div>
                    <div className="form-group">
                        <label htmlFor="syndicateMembers" className="col-sm-2 control-label">Syndicate members</label>
                        <div className="col-sm-10">
                            <input type="text"
                                   className="form-control"
                                   style={controlMaxWidthStyle}
                                   id="syndicateMembers"
                                   placeholder="Syndicate Members"
                                   value={this.state.project.syndicateMembers}
                                   onChange={this.inputChanged}/>
                        </div>
                    </div>
                    <div className="form-group">
                        <label htmlFor="targetCapital" className="col-sm-2 control-label">Target capital</label>
                        <div className="col-sm-10">
                            <div className="input-group" style={controlMaxWidthStyle}>
                                <span className="input-group-addon">$</span>
                                <input type="text"
                                       className="form-control"
                                       style={{textAlign: 'right'}}
                                       id="targetCapital"
                                       placeholder="Target Capital"
                                       value={this.state.project.targetCapital}
                                       onChange={this.inputChanged}/>
                                <span className="input-group-addon">.00</span>
                            </div>
                        </div>
                    </div>
                    <div className="form-group">
                        <label htmlFor="yield" className="col-sm-2 control-label">From Yield</label>
                        <div className="col-sm-10">
                            <div className="input-group" style={controlMaxWidthStyle}>
                                <input type="text"
                                       className="form-control"
                                       id="fromYield"
                                       placeholder="From Yield"
                                       value={this.state.project.fromYield}
                                       onChange={this.inputChanged}
                                       style={{textAlign: 'right'}}/>
                                <span className="input-group-addon">%</span>
                            </div>
                        </div>
                    </div>
                    <div className="form-group">
                        <label htmlFor="yield" className="col-sm-2 control-label">To Yield</label>
                        <div className="col-sm-10">
                            <div className="input-group" style={controlMaxWidthStyle}>
                                <input type="text"
                                       className="form-control"
                                       id="toYield"
                                       placeholder="To Yield"
                                       value={this.state.project.toYield}
                                       onChange={this.inputChanged}
                                       style={{textAlign: 'right'}}/>
                                <span className="input-group-addon">%</span>
                            </div>
                        </div>
                    </div>
                    <div className="form-group">
                        <label htmlFor="tenor" className="col-sm-2 control-label">Tenor</label>
                        <div className="col-sm-10">
                            <input type="text"
                                   className="form-control"
                                   style={controlMaxWidthStyle}
                                   id="tenor"
                                   placeholder="tenor"
                                   value={this.state.project.tenor}
                                   onChange={this.inputChanged}/>
                        </div>
                    </div>
                    <div className="form-group">
                        <label htmlFor="closesOn" className="col-sm-2 control-label">Closes on</label>
                        <div className="col-sm-10">
                            <input id="closesOn"
                                   className="form-control"
                                   style={controlMaxWidthStyle}
                                   type="date"
                                   value={this.state.project.closesOn}
                                   onChange={this.inputChanged}/>
                        </div>
                    </div>
                    <div className="form-group">
                        <label htmlFor="projectPicture" className="col-sm-2 control-label">Project picture</label>
                        <div className="col-sm-10">
                            <input id="projectPicture"
                                   className="file-control"
                                   style={{marginTop: '6px'}}
                                   type="file"
                                   onChange={this.loadPictureData}/>
                            { this.state.loadingPictureData ?
                                <span className="spinner" style={loadingFileStyle}></span> : undefined}
                        </div>
                    </div>
                    <hr style={{margin: '20px 0px 20px 0px'}}/>
                    <div className="form-group">
                        <div className="col-sm-offset-2 col-sm-10">
                            <button type="button"
                                    className="btn btn-default"
                                    disabled={this.state.isSaving}
                                    onClick={this.saveProject}>
                                {this.state.isSaving ? 'Saving...' : 'Save'}
                            </button>
                            <button type="button"
                                    className="btn btn-default"
                                    style={{marginLeft: '15px'}}
                                    onClick={this.props.onClose}>Close</button>
                        </div>
                    </div>
                    {this.state.errorMessage ?
                        <div className="col-sm-offset-2 col-sm-10" style={{padding: '4px'}}>
                            <div className="alert alert-danger" style={errorMessageStyle} >{this.state.errorMessage}</div>
                        </div>
                        : undefined}
                </form>
            </div>
        );
    }
}

class ProjectList extends Component {
    constructor(props) {
        super(props);
        this.projectService = ProjectService;
        this.state = {
            isLoading: true,
            errorMessage: '',
            projects: []
        }
    }

    componentDidMount() {
        this.refreshData();
    }

    refreshData = () => {
        this.setState({isLoading: true});
        this.projectService.projects()
            .done(projects => this.setState({projects: projects}))
            .fail(e => this.setState({errorMessage: e.responseText}))
            .always(() => this.setState({isLoading: false}))
    };

    render() {
        const loadingSpinner = this.state.isLoading ? <span className="spinner"></span> : undefined;

        const errorMessage = this.state.errorMessage ?
            <div className="alert alert-danger" style={errorMessageStyle}>{this.state.errorMessage}</div>
            : undefined;

        const projectRows =
            this.state.projects.map(p =>
                <tr>
                    <td>{p.title}</td>
                    <td>{p.formattedTargetCapital}</td>
                    <td>{p.formattedTenor}</td>
                    <td>{p.formattedYield}</td>
                    <td>{p.formattedClosesOn}</td>
                    <td>{p.formattedOtherDetails}</td>
                    <td>
                        <span className="glyphicon glyphicon-edit clickable"
                              title="Edit Project"
                              onClick={() => this.props.onEditProject(p)}></span>
                    </td>
                </tr>
            );

        return (
            <div>
                {errorMessage}
                <div style={{marginBottom: '5px'}}>
                    <button className="btn btn-default"
                            style={controlButtonStyle}
                            disabled={this.state.isLoading}
                            onClick={() => this.refreshData()}>
                        <span className="glyphicon glyphicon-refresh"></span>&nbsp;Refresh
                    </button>
                    <button className="btn btn-default"
                            style={{...controlButtonStyle, ...{marginLeft: '10px'}}}
                            onClick={() => this.props.onAddProject()}>
                        <span className="glyphicon glyphicon-plus"></span>&nbsp;Add Project
                    </button>
                    <div className="pull-right">{loadingSpinner}</div>
                </div>
                <table className="table table-striped small">
                    <thead>
                    <tr>
                        <th>Title</th>
                        <th>Target Capital</th>
                        <th>Tenor</th>
                        <th>Yield</th>
                        <th>Closes On</th>
                        <th>Other Details</th>
                        <th></th>
                    </tr>
                    </thead>
                    <tbody>
                    {projectRows}
                    </tbody>
                </table>
            </div>
        );
    }
}

export default class ProjectConsole extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isAddProject: false,
            addOrEditProject: undefined
        }
    }

    render() {
        if (this.state.addOrEditProject) {
            return <AddOrEditProject isAddProject={this.state.isAddProject}
                                     project={this.state.addOrEditProject}
                                     onClose={() => this.setState({addOrEditProject: undefined, isAddProject: false})}/>
        } else {
            return <ProjectList onAddProject={() => this.setState({addOrEditProject: {}, isAddProject: true})}
                                onEditProject={project => this.setState({addOrEditProject: project})}/>
        }
    }
}


// WEBPACK FOOTER //
// ./src/admin/projects.js